import React from "react";
import { useIdleTimer } from "react-idle-timer";
import ModalIds from "../../../constants/modalIds";
import { IDLE_TIMEOUT } from "../../../constants/shared";
import Color from "../../../enums/color";
import store from "../../../store";
import SectionsInfoModal from "../modal/SectionsInfoModal";
import CountdownIcon from "./CountdownIcon";
import { getAuthentication } from "../../../services/authentication/authenticationHelpers";
const IdleUserModalContainer = () => {
    const { reset } = useIdleTimer({
        timeout: IDLE_TIMEOUT,
        onIdle: () => store.modal[ModalIds.IDLE_USER].openModal(),
        crossTab: true
    });
    const handleConfirm = () => {
        reset();
        store.modal[ModalIds.IDLE_USER].closeModal();
    };
    const handleDisconnect = () => {
        var _a;
        store.modal[ModalIds.IDLE_USER].closeModal();
        (_a = getAuthentication()) === null || _a === void 0 ? void 0 : _a.requestLogOut();
    };
    return (<SectionsInfoModal id={ModalIds.IDLE_USER} icon={<CountdownIcon onFinish={handleDisconnect}/>} colorTheme={Color.CuriousBlue} title="IDLE_USER.MODAL.TITLE" okButtonProps={{
            onClick: handleConfirm
        }} cancelButtonProps={{
            name: "DISCONNECT",
            onClick: handleDisconnect
        }} sections={[
            {
                header: "IDLE_USER.MODAL.SUBTITLE1"
            },
            {
                header: "IDLE_USER.MODAL.SUBTITLE2",
                items: ["IDLE_USER.MODAL.CONSEQUENCE2_1", "IDLE_USER.MODAL.CONSEQUENCE2_2"]
            }
        ]}/>);
};
export default IdleUserModalContainer;
